import { render } from "./SynchronousForm.vue?vue&type=template&id=4535176a&scoped=true"
import script from "./SynchronousForm.vue?vue&type=script&lang=js"
export * from "./SynchronousForm.vue?vue&type=script&lang=js"

import "./SynchronousForm.vue?vue&type=style&index=0&id=4535176a&scoped=true&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4535176a"]])

export default __exports__